import { apiService } from '../../shared/services/apiService';
import { UpdateVideo, VideoCategory } from '../interface/video';
import { VideoPageType } from '../constants/videoPage';

type GetVideosResponse = {
  categories: VideoCategory[];
};

type DeleteVideoResponse = {
  status: string;
};

export const videosServices = {
  async getAllVideos(page: VideoPageType) {
    const resp = await apiService.get<GetVideosResponse>(`/api/coach/videos`, {
      params: { page },
    });

    return resp.data;
  },

  async getVideosBySuper(page: VideoPageType) {
    const resp = await apiService.get<GetVideosResponse>('api/coach/videos', {
      params: { page },
    });

    return resp.data;
  },

  async updateVideos(videos: { videos: UpdateVideo[] }, page: VideoPageType) {
    const resp = await apiService.put<GetVideosResponse>(
      'api/super/videos/save',
      videos,
      { params: { page } },
    );

    return resp.data;
  },

  async deleteVideoById(id: number) {
    const resp = await apiService.delete<DeleteVideoResponse>(`api/super/video/${id}`);

    return resp.data;
  },
};
